<template>
  <div class="page-box">
    <!-- 头部 -->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />

    <!-- 内容区域 -->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 会议直播 > 预约报名</div>
        <div class="recruitment-box">
          <div class="page-title">预约报名</div>
          <div class="recruitment-title">{{ liveDetails.title }}</div>
          <div class="recruitment-subtitle">{{ liveDetails.subTitle }}</div>
          <!-- 表单 -->
          <el-form v-if="!formSubmitted" :model="form" ref="formRef" :rules="rules" label-position="top">
            <div v-for="(item, index) in sentinelHospital" :key="index">
              <el-form-item v-if="item.type == 'ssqselect'" :label="(index + 1) + '. ' + item.title" prop="address">
                <el-cascader v-model="form['address']" :options="cityList"></el-cascader>
              </el-form-item>

              <el-form-item v-if="item.type == 'text'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <el-input v-model="form[item.field]" placeholder="请输入" :maxlength="item.maxLength" />
              </el-form-item>

              <el-form-item v-if="item.type == 'radio'" :label="(index + 1) + '. ' + item.title" :prop="item.field">
                <el-select v-model="form[item.field]" placeholder="请选择">
                  <el-option v-for="(itemTwo, indexTwo) in item.options" :key="indexTwo" :label="itemTwo" :value="itemTwo" />
                </el-select>
              </el-form-item>
            </div>
            <el-form-item style="text-align: center;">
              <el-button class="bt" type="primary" @click="submitForm">提交</el-button>
            </el-form-item>
          </el-form>
          <img v-else class="ok-two" src="@/assets/images/ok_two.png" style="margin: 50px auto; display: block;" />
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <footer-bar />
  </div>
</template>


<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import { getAgreementProblemList, addAgreement, getLiveDetail, getConferenceInformation } from '@/api/home'
const provinces = require('@/assets/address.json');

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav },
  data() {
    return {
      formSubmitted: false,
      selectedIndex: 3,
      form: {},
      rules: {},
      sentinelHospital: [], // 题目列表
      cityList: [],
      id: '',
      liveDetails: {}, // 直播详情
      introNameObj: {
        "A0": '医生',
        "A1": '护士',
        "A2": '其他技术人员',
        "A3": '',
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.addAgreement()
        } else {
          this.$message.error("请完善表单内容！");
          return false;
        }
      });
    },
    // 预约问题列表
    async getAgreementProblemList() {
      await getAgreementProblemList().then(res => {
        for (let i = 0; i < res.data.length; i++) {
          if (!res.data[i].field) {
            this.$set(this.form, 'address', '')
            this.$set(this.rules, 'address', [{
              required: true,
              message: res.data[i].type == 'text' ? `请输入${res.data[i].title}` : `请选择${res.data[i].title}`,
              trigger: res.data[i].type == 'text' ? 'blur' : 'change'
            }])
          } else {
            this.$set(this.form, res.data[i].field, '')
            this.$set(this.rules, res.data[i].field, [{
              required: true,
              message: res.data[i].type == 'text' ? `请输入${res.data[i].title}` : `请选择${res.data[i].title}`,
              trigger: res.data[i].type == 'text' ? 'blur' : 'change'
            }])
          }
        }
        this.$nextTick(() => {
          this.sentinelHospital = res.data
        })
      })
    },
    // 新增质控会议记录
    addAgreement() {
      let data = JSON.parse(JSON.stringify(this.form))
      data.liveId = this.id
      if (data.address) {
        data.provinceId = data.address[0]
        data.cityId = data.address[1]
        data.areaId = data.address[2]
      }
      this.$delete(data, 'address');
      addAgreement(data).then(res => {
        this.$message.success("提交成功！");
        this.formSubmitted = true;
        if (this.liveDetails.status == 'LIVING') {
          window.open(this.liveDetails.liveJumpAddress)
        }
      })
    },
    // 按 id 查询直播管理
    async getLiveDetail() {
      await getLiveDetail({
        id: this.id
      }).then(res => {
        this.liveDetails = res.data[0]
        this.formSubmitted = res.data[0].enrollmentStatus
      })
    },
    // 列表查询质控会议记录
    async getConferenceInformation() {
      await getConferenceInformation().then(res => {
        if(res.data.length > 0) {
          for(let key in this.form) {
            this.form[key] = res.data[0][key]
          }
          this.form.address = [res.data[0].provinceId, res.data[0].cityId, res.data[0].areaId]
          this.form.introName = this.introNameObj[res.data[0].intro]
        }
      })
    },
    getCityListTree() {
      this.cityList = provinces.provinces
      // getCityListTree().then(res => {
      //   this.cityList = res.data
      // })
    },
  },
  async mounted() {
    this.id = this.$route.params.id
    this.getCityListTree()
    await this.getAgreementProblemList()
    await this.getLiveDetail()
    await this.getConferenceInformation()
  },
};
</script>


<style lang="less" scoped>
.ok-two {
  width: 200px;
  height: auto;
}

.qualityControl-box {
  padding-bottom: 20px;
}

.recruitment-box {
  background: #fff;
  text-align: left;
  border-radius: 6px;
  margin-top: 25px;
  padding: 40px 50px 10px 50px;

  /deep/.el-select {
    width: 100%;
  }

  /deep/.el-cascader {
    width: 100%;
  }
}

.recruitment-title {
  color: #A41218;
  font-size: 32px;
  font-weight: 600;
  line-height: 32px;
  margin-bottom: 14px;
  text-align: center;
}

.recruitment-subtitle {
  color: #A41218;
  font-size: 18px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 34px;
  text-align: center;
}

.page-title {
  color: #2A2A2A;
  font-weight: 500;
  line-height: 32px;
  font-size: 24px;
  margin-bottom: 34px;
  text-align: left;
}

.bt {
  background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
  color: #fff;
  font-size: 16px;
  height: 44px;
  border-radius: 50px;
  width: 255px;
  border: none;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/Recruitment/index3.vue